export enum RoleType {
    User = 0,
    GlobalAdmin = 1,
    CompanyAdmin = 2,
}